import { RowTable } from '../../../../func/components/Table';
import { HouseInfoProps } from '../../data';

interface Props {
  houseInfo: HouseInfoProps;
}

const HouseMapping = {
  totalfloorarea: '연면적',
  groundfloornum: '건물층수',
  buildingtolandratio: '건폐율',
  floorarearatio: '용적률',
  mainpurposecodename: '주용도',
  structurecodename: '건물구조',
  created_year: '노후년도',
};

const transformData = (data: Record<string, any>) => {
  return Object.entries(HouseMapping).map(([key, label]) => {
    let value = data[key] ?? '-';

    switch (label) {
      case '연면적':
        value = `${data[key]}m² (${Number(data['totalfloorpyeong']).toFixed(2)}평)`;
        break;
      case '용적률':
        value = `${data[key]}%`;
        break;
      case '건폐율':
        value = `${data[key]}%`;
        break;
      case '건물층수':
        value = `${data[key]}층${data['undergroundfloor'] ? `/지하${data['undergroundfloor']}층` : ''}`;
        break;
      case '노후년도':
        value =
          data.created_year && data.old_year
            ? `${data.created_year}년 (노후${data.old_year}년)`
            : '-';
        break;
    }

    return { key: label, value };
  });
};

const BuildingInfo = ({ houseInfo }: Props) => {
  return <RowTable data={transformData(houseInfo)} titleWidth={110} />;
};

export default BuildingInfo;
